export const isMobile = (): boolean => 'ontouchstart' in window
